import { TypographyProps } from '@mui/material';
import { LabelSmall, Row } from '../../styles';
import styled from '@emotion/styled';
import { shouldForwardProps } from '../../utils';

interface BadgeProps extends TypographyProps {
    title: string;
    textColor?: string;
    icon?: React.ReactNode;
}

export const Badge = ({ title, textColor, icon }: BadgeProps) => {
    return (
        <BadgeRow px={0.5}>
            {icon && icon}
            <StyledLabel color={textColor}>{title}</StyledLabel>
        </BadgeRow>
    );
};

const StyledLabel = styled(LabelSmall, shouldForwardProps)`
    width: fit-content;
    text-align: center;
    white-space: nowrap;
    color: ${({ color, theme }) => color ?? theme.colors.white};
`;

const BadgeRow = styled(Row, shouldForwardProps)<{
    bgcolor?: string;
}>`
    background-color: ${({ bgcolor, theme }) => bgcolor ?? theme.colors.onPrimaryDark};
    border-radius: 8px;
    justify-items: center;
    justify-content: center;
    height: 16px;
    gap: 2px;
`;
